import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, RouterModule } from '@angular/router';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { SegmentModule } from "ngx-segment-analytics";
import { environment } from 'environments/environment';
import { NgxIziToastModule } from 'ngx-izitoast';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './core/auth/error.interceptor';
import { CustomPreloading } from './core/services/customPreloading.service';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeSp from "@angular/common/locales/es";
import localeDe from "@angular/common/locales/de";
import localeEn from "@angular/common/locales/en";
import localeFr from "@angular/common/locales/fr";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TimeagoModule } from 'ngx-timeago';
import { TooltipModule } from 'ng2-tooltip-directive';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from './shared/shared.module';
import { KB_PORTAL_SSR_INITIALIZER } from './core/i18n/kb-portal-ssr.initializer';
import { ApiService } from './core/services/api.service';

const routerConfig: ExtraOptions = {
  preloadingStrategy: CustomPreloading,
  scrollPositionRestoration: "enabled",
  anchorScrolling: "enabled",
  initialNavigation: 'enabledBlocking',
  malformedUriErrorHandler: (_error, urlSerializer) => urlSerializer.parse('/404'),
};

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  const isLocal = environment.isLocal;
  const domain = environment.domainType;
  if (isLocal == 1) {
    return new TranslateHttpLoader(http, `assets/i18n/`, ".json");
  } else {
    if (domain == "dev") {
      return new TranslateHttpLoader(
        http,
        environment.dev_bunnycdn_url + 'assets/i18n/',
        ".json"
      );
    } else {
      return new TranslateHttpLoader(
        http,
        environment.io_bunnycdn_url + 'assets/i18n/',
        ".json"
      );
    }
  }
}

function getStoredLanguage(): string {
  if (typeof localStorage === 'undefined') {
    return 'en';
  }
  return localStorage.getItem('language') || 'en';
}



const lang = getStoredLanguage();
registerLocaleData(
  lang == "es"
    ? localeSp
    : lang == "fr"
      ? localeFr
      : lang == "de"
        ? localeDe
        : localeEn
);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'deskudocs' }),
    BrowserTransferStateModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes, routerConfig),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    FuseModule,
    FuseConfigModule.forRoot(appConfig),
    CoreModule,
    NgxIziToastModule,
    SegmentModule.forRoot({
      apiKey: ApiService.convertDecryptData(
        environment.domainType == "dev"
          ? environment.devConsoleSegmentApiKey
          : environment.ioConsoleSegmentApiKey
      ),
      debug: false,
      loadOnInitialization: typeof window !== 'undefined',
    }),
    TimeagoModule.forRoot(),
    TooltipModule,
    MatIconModule,
    SharedModule
  ],
  exports: [
  ],
  bootstrap: [
    AppComponent
  ],
  providers: [
    KB_PORTAL_SSR_INITIALIZER,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: LOCALE_ID,
      useValue:
        lang == "es"
          ? "es-ES"
          : lang == "fr"
            ? "fr-FR"
            : lang == "de"
              ? "de-DE"
              : "en-EN",
    }
  ]
})

export class AppModule {
}
